import { useCallback, useMemo } from 'react';
import useTranslation from 'next-translate/useTranslation';

import type { ContestCardActionBanner } from '~/domains/contest/domains/common/components/ContestCard/types';

import type { MyUserContest } from '../types/userContest';

import useGetActionBannerInfo from './useGetActionBannerInfo';

function useGetMyContestBannerInfo({ isEliminationShown }: { isEliminationShown: boolean }) {
  const { t } = useTranslation('contest');
  const { getActionBannerInfo } = useGetActionBannerInfo();

  const eliminatedBanner = useMemo<ContestCardActionBanner>(
    () => ({ color: 'gray', content: t('common.contestCard.banner.eliminated') }),
    [t]
  );

  const getMyContestBannerInfo = useCallback(
    (contest: MyUserContest): ContestCardActionBanner | undefined => {
      if (isEliminationShown && contest.leaderboard?.isUserEliminated) {
        return eliminatedBanner;
      }

      return getActionBannerInfo(contest.alerts);
    },
    [eliminatedBanner, getActionBannerInfo, isEliminationShown]
  );

  return { getMyContestBannerInfo };
}

export default useGetMyContestBannerInfo;
